const getI18nData =
  (
    i18nData:
      | {
          edges: {
            node: {
              name?: string | null;
              childSrcJson?: {
                [k: string]: string | any;
              };
            };
          }[];
        }
      | null
      | undefined,
    i18nKey: string,
  ) =>
  (
    key: string,
    interpolations: {
      [key: string]: string | number;
    } = {},
    wrappedStrings: string[] = [],
  ) => {
    if (!i18nData) return '';

    let primaryTranslationEdge = (i18nData.edges || []).find(edge => edge.node.name === 'en');

    const secondaryTranslationEdge = primaryTranslationEdge;

    if (i18nKey !== 'en') {
      primaryTranslationEdge = (i18nData.edges || []).find(edge => edge.node.name === i18nKey);
    }

    if (primaryTranslationEdge || secondaryTranslationEdge) {
      const primaryTranslations = primaryTranslationEdge ? primaryTranslationEdge.node.childSrcJson : {};
      const secondaryTranslations = secondaryTranslationEdge!.node.childSrcJson;

      let thisKey = key.replace(new RegExp('-', 'g'), '_');

      // Pluralization
      if ('count' in interpolations) {
        const { count } = interpolations;

        if (['en', 'de', 'es-LA', 'nl', 'pt-BR'].indexOf(i18nKey) !== -1) {
          thisKey += count === 1 ? '_one' : '_other';
        }

        if (i18nKey === 'fr-FR') {
          thisKey += count <= 1 ? '_one' : '_other';
        }

        if (i18nKey === 'ja') {
          thisKey += '_other';
        }
      }

      // Data Retrieval
      let value =
        (primaryTranslations && primaryTranslations[thisKey]) ||
        (secondaryTranslations && secondaryTranslations[thisKey]) ||
        '';

      // Interpolation
      Object.keys(interpolations).forEach(interpolation => {
        value = value.split(`{${interpolation}}`).join(interpolations[interpolation]);
      });

      // Wrapped Strings
      for (let i = 0; i < wrappedStrings.length; i += 1) {
        const wrappedString = wrappedStrings[i];
        const matches = value.match(new RegExp(`<w${i}>(.*)</w${i}>`));
        value = value.replace(matches[0], wrappedString.replace('{}', matches[1]));
      }

      // Remove remaining <w*> tags
      value = value.replace(/<\/?w\d+>/g, '');

      return value;
    }

    return '';
  };

export default getI18nData;
